export default class slider {
   constructor(el){
      this.el = el;
      this.content = $(this.el).find('.slider--content');
      this.slides = $(this.el).find('.slider--content--slide');
      this.binds();

      setTimeout(function(){
         $(el).find('.slider--text').addClass('in');
      }, 400);

      console.log('slider',this);

      const t = this;

      t.setInterval = function(){
         clearInterval(t.to);
         t.to = setInterval(function(){
            $(t.content).css('scroll-snap-type','none');
            let curX = $(t.content).scrollLeft();
            let maxX = $(t.content).get(0).scrollWidth - window.innerWidth;
            let scrTo = curX + window.innerWidth;
            if(curX == maxX) scrTo = 0;
            console.log(scrTo);
            $(t.content).animate({'scrollLeft' : scrTo}, 600, () => {
               $(t.content).css('scroll-snap-type','x mandatory');
            });
         }, 4000);
      }

      t.setInterval();
   }

   binds(){
      const par = this;

      $(par.content).on('wheel', function(){
         clearInterval(par.to);
         clearTimeout(par.set);
         par.set = setTimeout(function(){
            par.setInterval();
         }, 1000);
      });

      $(par.content).on('scroll', function(e){
         console.log(e.clientX);
         $(par.slides).each(function(){
            let rect = this.getBoundingClientRect();
            if(rect.right >= window.innerWidth*.5 && rect.left < window.innerWidth*.5) {
               if(!$(this).hasClass('cur')) {
                  $(this).addClass('cur');
                  var curSliderText = $(par.el).find('.slider--text');
                  var sama = $(curSliderText).text().trim()===this.dataset.title.trim();
                  if(!sama){
                     $(curSliderText).addClass('out');
                  }
                  setTimeout(function(){
                     $(curSliderText).remove();
                  }, !sama ? 300 : 10);
                  var newSliderText = $(`<div class="slider--text">
                  <h2>${this.dataset.title||''}</h2>
                  <p>${this.dataset.caption||''}</p>
               </div>`);
                  $(par.el).append(newSliderText);
                  $(newSliderText).addClass('in');
               }
            } else {
               $(this).removeClass('cur');
            }
         });
      });
   }
}